import {Expose} from 'class-transformer';

export class GraphLinkModel {
  constructor(init?: Partial<GraphLinkModel>) {
    Object.assign(this, init);
  }
  @Expose({ name: 'SourceId' })
  source: string;
  @Expose({ name: 'TargetId' })
  target: string;
  @Expose({ name: 'Label' })
  label?: any;
}
